
/* ===== VELANTIS_NZ — Novedades 2026 + Preventa (dinámico por marca) ===== */
(function(){
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function norm(s){return (s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().replace(/[^A-Z0-9]+/g,' ').trim();}
  function CAT(){return window.VELANTIS_CAT||[];}
  function resolve(id){ id=String(id||'').trim(); if(!id)return null; var up=id.toUpperCase();
    var s=CAT().find(function(r){return r[12] && String(r[12]).toUpperCase()===up;}); if(s)return s;
    var n=norm(id); return CAT().find(function(r){return norm(r[0])===n;})||null; }
  function priceHTML(r){ return (r[1]==='Ambiental')?('$'+(r[11]||449)+' MXN'):('$'+(r[11]||590)+' MXN'); }
  // item puede ser: string (SKU/nombre -> del catálogo) u objeto {name,brand,gender,family,img,price,sku}
  function toTuple(item){
    if(item && typeof item==='object'){
      var fam=item.family||'';
      return [item.name||'', item.gender||'Unisex', item.brand||'', fam, (fam.split(' ')[0]||fam), '','','','', item.img||'amaderados', '', item.price||499, item.sku||''];
    }
    return resolve(item);
  }
  function card(r,mode,isDef){
    var key=esc(r[9]||'amaderados');
    var title = r[12] ? ('<span class="nz-sku">'+esc(r[12])+'</span><h3>'+esc(r[0])+'</h3>')
                      : ('<span class="nz-sku nz-name">'+esc(r[0])+'</span>');
    var fam = (r[3]?esc(r[3])+(r[2]?' · ':''):'')+(r[2]?'Inspirado en '+esc(r[2]):'');
    return '<article class="nz-card"'+(isDef?' data-preventa="1"':'')+' data-name="'+esc(r[0])+'" data-price="'+(r[11]||590)+'" data-img="n-'+key+'" data-sub="'+esc(r[3])+'">'+
      '<div class="cat-img n-'+key+'"></div>'+
      '<span class="nz-tag'+(mode==='pre'?' pre':'')+'">'+(mode==='pre'?'Preventa':'Nuevo 2026')+'</span>'+
      '<div class="nz-body">'+ title +
        '<p class="nz-fam">'+fam+'</p>'+
        '<div class="nz-foot"><span class="nz-price">'+priceHTML(r)+'</span></div>'+
        '<button class="add nz-btn" type="button">'+(mode==='pre'?'Reservar en preventa':'Agregar al carrito')+'</button>'+
      '</div></article>';
  }
  function groups(list,mode){
    var g={}, order=[];
    (list||[]).forEach(function(item){ var isDef=(item&&typeof item==='object'); var r=toTuple(item); if(!r)return;
      var b=r[2]||'Otras marcas'; if(!g[b]){g[b]=[];order.push(b);} g[b].push({r:r,def:isDef}); });
    order.sort(function(a,b){return a.localeCompare(b);});
    if(!order.length) return '<div class="nz-empty">Muy pronto — estamos preparando los próximos lanzamientos.</div>';
    return order.map(function(b){
      return '<div class="nz-brand"><div class="nz-brand-head"><span class="nz-brand-name">'+esc(b)+'</span>'+
        '<span class="nz-brand-count">'+g[b].length+(g[b].length===1?' fragancia':' fragancias')+'</span></div>'+
        '<div class="nz-grid">'+g[b].map(function(e){return card(e.r,mode,e.def);}).join('')+'</div></div>';
    }).join('');
  }
  function render(){
    var nov=window.VELANTIS_NOVEDADES||[], pre=window.VELANTIS_PREVENTA||[];
    var preHTML=groups(pre,'pre'), fch=window.VELANTIS_PREVENTA_FECHA;
    var ng=document.getElementById('novGrid'); if(ng) ng.innerHTML=groups(nov,'nov');
    var pg=document.getElementById('preGrid'); if(pg) pg.innerHTML=preHTML;
    var pg2=document.getElementById('prePageGrid'); if(pg2) pg2.innerHTML=preHTML;
    var teaser=document.getElementById('preventaTeaser'); if(teaser) teaser.hidden = !(pre && pre.length);
    if(fch){ var t='Reserva ahora · entrega estimada '+fch+'. Asegura tu unidad antes de la llegada oficial.';
      var sub=document.getElementById('preSub'); if(sub) sub.textContent=t;
      var sub2=document.getElementById('prePageSub'); if(sub2) sub2.textContent=t; }
  }
  function route(){
    var isPre=/^#\/preventa\/?$/.test(location.hash||'');
    document.body.classList.toggle('preventa', isPre);
    var pp=document.getElementById('preventaPage'); if(pp) pp.hidden=!isPre; // vencer [hidden]!important
    if(isPre){ render(); window.scrollTo(0,0); }
  }
  window.addEventListener('hashchange',route);
  // clic en tarjeta -> ficha (excepto el botón, que agrega/reserva)
  document.addEventListener('click',function(e){
    if(e.target.closest('.nz-btn')) return;
    var c=e.target.closest('.nz-card'); if(!c) return;
    if(c.getAttribute('data-preventa')==='1') return; // preventa: solo el botón reserva
    var name=c.getAttribute('data-name');
    if(window.VelantisProducto && window.VelantisProducto.open) window.VelantisProducto.open(name);
    else location.hash='#/p/'+encodeURIComponent(name);
  });
  function boot(){ render(); route(); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  window.VELANTIS_NZ={render:render};
})();
